import { PayloadAction } from '@reduxjs/toolkit';
import { ENUM__redux_action } from '../_base/ENUM__redux_action';
import { STATE__network } from './STATE__network';

interface PAYLOAD {
  id: string;
  is_waiting: boolean;
}

export const LOCAL__network_set_waiting_response = (payload: PAYLOAD): PayloadAction<PAYLOAD> => ({
  payload,
  type: ENUM__redux_action.NETWORK__SET_WAITING_RESPONSE,
});

export function INIT_LOCAL__network_set_waiting_response(state: STATE__network, action: PayloadAction<PAYLOAD>) {
  let { responses_ids__wait_to } = state;

  let { id, is_waiting } = action.payload;

  is_waiting ? responses_ids__wait_to.add(id) : responses_ids__wait_to.delete(id);

  state.responses_ids__wait_to = new Set(responses_ids__wait_to);
}
